<template>
  <p class="mt-1 max-w-2xl text-sm text-gray-500">
    <slot></slot>
  </p>
</template>


<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const redirect = () => router.push({ name: 'onboarding.show' });
const mounted = onMounted(redirect);
</script>
